<template>
  <Input
    data-slot="input-group-control"
    :class="cn(
      'tw:flex-1 tw:rounded-none tw:border-0 tw:bg-transparent tw:focus-visible:ring-0 tw:focus-visible:ring-transparent tw:ring-offset-transparent tw:dark:bg-transparent',
      'tw:shadow-none',
      props.class,
    )"
  />
</template>

<script setup>
import { Input } from '@/shadcn/components/ui/input'
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
